import axios from 'axios';
import api, { NEXTJS_API_URL } from './client';

export const authAPI = {
  login: async (credentials) => {
    try {
      // Use Next.js API for login - determine if it's email or username
      const payload = {
        password: credentials.password,
      };

      // Check if the input looks like an email
      if (credentials.username && credentials.username.includes("@")) {
        payload.email = credentials.username;
      } else {
        payload.username = credentials.username;
      }

      const response = await axios.post(`${NEXTJS_API_URL}/login`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Handle Next.js login response format: { user, token, message }
      if (response.data.user && response.data.token) {
        return {
          user: response.data.user,
          token: response.data.token,
        };
      } else {
        throw {
          response: {
            data: { message: response.data.message || "Login failed" },
          },
        };
      }
    } catch (error) {
      if (error.response) {
        throw {
          response: {
            data: { message: error.response.data?.message || "Login failed" },
          },
        };
      }
      throw error;
    }
  },

  eclabLogin: async (credentials) => {
    try {
      const loginUrl = new URL(`${NEXTJS_API_URL}/elab/login`);
      const eclabEnv =
        import.meta.env.VITE_ECLAB_ENVIRONMENT ||
        import.meta.env.VITE_ECLAB_ENV;
      if (eclabEnv) {
        loginUrl.searchParams.set("env", eclabEnv);
      }

      const response = await axios.post(
        loginUrl.toString(),
        {
          username: credentials.username,
          password: credentials.password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Handle E-CLAB login response format: { user, token, message, eclabData }
      if (response.data.user && response.data.token) {
        return {
          user: response.data.user,
          token: response.data.token,
          eclabData: response.data.eclabData,
        };
      } else {
        throw {
          response: {
            data: { message: response.data.error || "E-CLAB login failed" },
          },
        };
      }
    } catch (error) {
      if (error.response) {
        throw {
          response: {
            data: {
              message: error.response.data?.error || "E-CLAB login failed",
            },
          },
        };
      }
      throw error;
    }
  },

  register: async (userData) => {
    const response = await api.post("/auth/register", userData);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get("/me");
    return response.data?.data || response.data; // Handle both response formats
  },

  changePassword: async ({ currentPassword, newPassword, confirmPassword }) => {
    try {
      const payload = {
        current_password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      };
      const response = await api.post("/me/change-password", payload);
      // Normalize response shape
      return (
        response.data?.message ||
        response.data?.data?.message ||
        "Password changed successfully"
      );
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message ||
        "Failed to change password";
      throw { response: { data: { message: msg } } };
    }
  },

  requestPasswordReset: async ({ email, userType }) => {
    try {
      const response = await api.post("/auth/forgot-password", { email, user_type: userType });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

// User Management API
